import $$ from 'cmn-utils'

const baseUrl = "/api/sys/about/";
export default {
    get: (params) => {
        return $$.get(baseUrl + 'get', params)
    },
    update: (params) => {
        return $$.post(baseUrl + 'update', params)
    },

}